import { CopyIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Flex,
  Image,
  InputGroup,
  InputRightElement,
  Textarea,
  useBreakpointValue,
  useToast,
} from '@chakra-ui/react';
import { useUserContext } from 'src/contexts/UserContext';
import { copyToClipboard } from 'src/utils/copyToClipboard';
import { createReferralWidgetLink } from 'src/utils/createReferralLink';
import ReferralWidgetIlust from 'src/img/widget-lojista.png';
import { mountWidgetCode } from './utils';
import { ReferralTabHeader } from '../components';

export const ReferralWidgetTabContent = () => {
  const { userData } = useUserContext();
  const toastPosition = useBreakpointValue({
    base: 'top-center',
    md: 'bottom-left',
  });
  const toast = useToast({ position: toastPosition });

  const referralWidgetLink = createReferralWidgetLink(userData?.Multivendor);
  const widgetCode = mountWidgetCode(referralWidgetLink);

  const handleCopyCode = () => {
    copyToClipboard(widgetCode);
    toast({
      title: 'Código copiado',
      status: 'success',
    });
  };

  return (
    <Box textAlign="start">
      <ReferralTabHeader
        title="Venda no atacado no seu site"
        subtitle="Copie e cole o código do widget no seu site, o botão direciona o lojista
        para o seu perfil da Inventa."
      />

      <Flex gap={6} flexDir={{ base: 'column', md: 'row' }}>
        <Box flex={1}>
          <InputGroup onClick={handleCopyCode} cursor="pointer" mb={5}>
            <Textarea
              pointerEvents="none"
              rows={4}
              cols={50}
              pr={7}
              wordBreak="break-all"
              resize="none"
              value={widgetCode}
              color="gray.500"
              bgColor="gray.50"
              readOnly
              py={1}
              lineHeight={6}
              overflow="hidden"
            />
            <InputRightElement>
              <CopyIcon />
            </InputRightElement>
          </InputGroup>
          <Button
            colorScheme="yellow"
            onClick={handleCopyCode}
            size="lg"
            w={{ base: '100%', md: 'auto' }}
          >
            Copiar código
          </Button>
        </Box>
        <Image
          flex={0.8}
          flexGrow={1}
          w={{ base: '100%', md: 0 }}
          maxH={360}
          objectFit="contain"
          src={ReferralWidgetIlust}
          alt="Botão Comprar no atacado no site"
        />
      </Flex>
    </Box>
  );
};
